import React from "react";
import { ArticleCard } from "..";
import { features } from "../../utils/constants";
import * as Animate from "react-reveal"

const featuresSlice = features.slice(0, 6);
export default function () {
  return (
    <section className="flex flex-col">
      <div className="flex flex-col items-center justify-center cstm-bg-green-gradient pt-8 lg:pt-16 pb-10 lg:pb-16">
        <Animate.Fade bottom>
          <h3 className=" text-center md:text-left font-semibold text-2xl md:text-3xl lg:text-4xl mt-10">
          What the media says about us
          </h3>
          <div className="w-11/12 mx-auto my-16 flex flex-col gap-y-16 max-w-7xl">
            <div className="grid auto-cols-fr grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 grid-rows-2 gap-8">
              {featuresSlice.map((feature) => {
                return <ArticleCard key={feature.id} feature={feature} />;
              })}
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
}
